import React from 'react'
import Group from 'components/utils/Group'
import BodyText from 'components/Luxkit/Typography/BodyText'
import PriceRowPriceWithCaption from 'components/Luxkit/PricePoints/PriceRowPriceWithCaption'
import PriceRowValueDiscount from 'components/Luxkit/PricePoints/Value/PriceRowValueDiscount'
import PriceRowCaption from 'components/Luxkit/PricePoints/PriceRowCaption'

export interface PriceRoomTypeProps {
  priceFrom: App.CruisePriceDetails;
  header?: boolean;
  hasValidDepartures?: boolean;
}

function CruisePriceRoomTypeInfo({ priceFrom, hasValidDepartures, header = false }: PriceRoomTypeProps): JSX.Element {
  return (
    <>
      {hasValidDepartures && <div>
        <PriceRowPriceWithCaption
            size="S"
            caption="From"
            price={priceFrom.total}
            saleUnit="person"
          />
        <PriceRowCaption>Twin share</PriceRowCaption>

        {!header && priceFrom.discountPills?.discountPercentage && <PriceRowValueDiscount
            type="estimate"
            discountPercentage={priceFrom.discountPills.discountPercentage}
          />}
      </div>}

      {!hasValidDepartures && <Group direction="vertical" verticalAlign="center" fullWidth>
        <BodyText variant="large" weight="bold" align="center">
          This offer has sold out
        </BodyText>
      </Group>}

    </>
  )
}

export default CruisePriceRoomTypeInfo
